import { render, staticRenderFns } from "./task.vue?vue&type=template&id=59ebabee&scoped=true&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&id=59ebabee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ebabee",
  null
  
)

export default component.exports